export class AdminImportExportController {
  constructor () {
    var AdminImportExport = this;
    AdminImportExport.stateUrl = '/import_export';
    AdminImportExport.controllerName = 'AdminImportExportController'
  }
}


// WEBPACK FOOTER //
// ./states/admin/import_export/import_export.controller.js